import script from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuHorizontal.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuHorizontal.vue?vue&type=style&index=0&id=281fd17d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-281fd17d"]])

export default __exports__